import React from "react";
import {
  ContainerTab,
  InputCEPFormStyled,
  InputPhoneFormStyled,
  Row,
} from "../../styles";
import Field from "../../components/Field";
import {
  InputDateForm,
  InputForm,
} from "../../../../../components/Modal/Input";
import { consultaDeCep } from "../../../../../services/EnderecoService";

const DadosCadastrais = ({ internacao, handleField }) => {
  const { sujeitoAtencao } = internacao;
  const {
    nome,
    endereco,
    contato,
    rg,
    documento,
    sexo,
    dataNascimento,
    idade,
    dadosConvenio,
    ocupacao,
    nomeConjuge,
    nomeMae,
    nomePai,
    estadoCivil,
    origem,
    quemIndicou,
  } = sujeitoAtencao || {};

  const { cep, nomeLogradouro, bairro, municipio, numero } = endereco || {};

  const { telefonePrincipal, telefoneSecundario, email } = contato || {};

  const { convenio, numeroCarteira, validadeCarteira } = dadosConvenio || {};

  const { municipio: municipioOrigem } = origem || {};

  const handleFieldSujeitoAtencao = (value, field) => {
    const dadosSujeitoAtencao = internacao.sujeitoAtencao;
    dadosSujeitoAtencao[field] = value;

    handleField("sujeitoAtencao", dadosSujeitoAtencao);
  };

  const onCEPChange = async (e) => {
    const { value } = e.target;

    const cepSemMascara = value.replace(/\D/g, "");
    if (cepSemMascara.length === 8) {
      const response = await consultaDeCep(cepSemMascara);
      const responseConsultaDeCep = response?.data?.data?.consultaDeCep || {};
      if (responseConsultaDeCep) {
        const { logradouro, bairro, municipio } = responseConsultaDeCep;

        const dadosSujeitoAtencao = {
          ...internacao.sujeitoAtencao,
          endereco: {
            nomeLogradouro: logradouro,
            bairro,
            municipio,
            uf: municipio?.estado?.uf,
          },
        };

        handleField("sujeitoAtencao", dadosSujeitoAtencao);
      }
    }

    handleFieldSujeitoAtencao(value, "cep");
  };

  const handleFieldUpdate = (value, type, field) => {
    const dadosAcompanhante = {
      ...internacao.responsavel,
      [type]: {
        ...internacao.responsavel[type],
        [field]: value
      }
    };
  
    handleField("sujeitoAtencao", dadosAcompanhante);
  };

  return (
    <ContainerTab>
      <Row>
        <Field label="Nome" width="80%">
          <InputForm
            id="agd-dca-inp-nom"
            value={nome}
            onChange={(e) => handleFieldSujeitoAtencao(e.target.value, "nome")}
            disabled
          />
        </Field>
        <Field label="Sexo" width="20%">
          <InputForm
            id="agd-dca-inp-sex"
            value={sexo?.descricao || ""}
            disabled
          />
        </Field>
      </Row>
      <Row>
        <Field label="Data nascimento">
          <InputDateForm
            id="agd-dca-inp-nsc"
            value={dataNascimento}
            onChange={(date) =>
              this.handleFieldSujeitoAtencao(date, "dataNascimento")
            }
            iconposition="end"
            disabled
          />
        </Field>
        <Field label="Idade">
          <InputForm id="agd-dca-inp-ida" value={idade} disabled />
        </Field>
        <Field label="RG">
          <InputForm
            id="agd-dca-inp-rg"
            value={rg}
            onChange={(e) => handleFieldSujeitoAtencao(e.target.value, "rg")}
            disabled
          />
        </Field>
        <Field label="CPF">
          <InputForm
            id="agd-dca-inp-cpf"
            value={documento}
            onChange={(e) =>
              handleFieldSujeitoAtencao(e.target.value, "documento")
            }
            disabled
          />
        </Field>
      </Row>
      <Row>
        <Field label="Telefone principal">
          <InputPhoneFormStyled
            id="agd-dca-inp-tp1"
            value={telefonePrincipal}
            onChange={(e) =>
              handleFieldUpdate(e.target.value, "contato", "telefonePrincipal")
            }
            disabled
          />
        </Field>
        <Field label="Telefone secundário">
          <InputPhoneFormStyled
            id="agd-dca-inp-tp2"
            value={telefoneSecundario}
            onChange={(e) =>
              handleFieldUpdate(e.target.value, "contato", "telefoneSecundario")
            }
            disabled
          />
        </Field>
        <Field label="E-mail">
          <InputForm
            id="agd-dca-inp-eml"
            value={email}
            onChange={(e) => handleFieldUpdate(e.target.value, "contato", "email")}
            disabled
          />
        </Field>
      </Row>
      <Row>
        <Field label="Cônjuge">
          <InputForm
            id="agd-dca-inp-cnj"
            value={nomeConjuge}
            onChange={(e) =>
              handleFieldSujeitoAtencao(e.target.value, "nomeConjuge")
            }
            disabled
          />
        </Field>
        <Field label="Nome mãe">
          <InputForm
            id="agd-dca-inp-mae"
            value={nomeMae}
            onChange={(e) =>
              handleFieldSujeitoAtencao(e.target.value, "nomeMae")
            }
            disabled
          />
        </Field>
        <Field label="Nome pai">
          <InputForm
            id="agd-dca-inp-pai"
            value={nomePai}
            onChange={(e) =>
              handleFieldSujeitoAtencao(e.target.value, "nomePai")
            }
            disabled
          />
        </Field>
        <Field label="Indicado">
          <InputForm
            id="agd-dca-inp-ind"
            value={quemIndicou}
            onChange={(e) =>
              handleFieldSujeitoAtencao(e.target.value, "quemIndicou")
            }
            disabled
          />
        </Field>
      </Row>
      <Row>
        <Field label="Profissão">
          <InputForm
            id="agd-dca-inp-prf"
            value={ocupacao?.descricao || ""}
            disabled
          />
        </Field>
        <Field label="Estado Civil">
          <InputForm
            id="agd-dca-inp-ecv"
            value={estadoCivil?.descricao || ""}
            disabled
          />
        </Field>
        <Field label="Naturalidade">
          <InputForm
            id="agd-dca-inp-nat"
            value={municipioOrigem?.descricao || ""}
            disabled
          />
        </Field>
      </Row>
      <Row>
        <Field label="Convênio">
          <InputForm
            id="agd-dca-inp-cnv"
            value={convenio?.descricao || ""}
            disabled
          />
        </Field>
        <Field label="N cartão">
          <InputForm
            id="agd-dca-inp-car"
            value={numeroCarteira}
            onChange={(e) =>
              handleFieldUpdate(e.target.value, "dadosConvenio", "numeroCarteira")
            }
            disabled
          />
        </Field>
        <Field label="Validade">
          <InputDateForm
            id="agd-dca-inp-val"
            value={validadeCarteira}
            onChange={(date) =>
              this.handleFieldUpdate(date, "dadosConvenio", "validadeCarteira")
            }
            iconposition="end"
            disabled
          />
        </Field>
      </Row>

      <Row>
        <Field label="CEP">
          <InputCEPFormStyled
            id="agd-dca-inp-cep"
            type="text"
            onChange={(e) => onCEPChange(e)}
            value={cep}
            disabled
          />
        </Field>
        <Field label="Endereço">
          <InputForm
            id="agd-dca-inp-end"
            value={nomeLogradouro}
            onChange={(e) =>
              handleFieldUpdate(e.target.value, "endereco", "nomeLogradouro")
            }
            disabled
          />
        </Field>
        <Field label="Número">
          <InputForm
            id="agd-dca-inp-num"
            value={numero}
            onChange={(e) => handleFieldUpdate(e.target.value, "endereco", "numero")}
            disabled
          />
        </Field>
      </Row>
      <Row>
        <Field label="Bairro">
          <InputForm
            id="agd-dca-inp-bai"
            value={bairro}
            onChange={(e) => handleFieldUpdate(e.target.value, "endereco", "bairro")}
            disabled
          />
        </Field>
        <Field label="Cidade">
          <InputForm
            id="agd-dca-inp-cid"
            value={municipio ? `${municipio.nome} - ${municipio.uf}` : ""}
            disabled
          />
        </Field>
      </Row>
    </ContainerTab>
  );
};

export default DadosCadastrais;
